const __request = require(`../__request/__request_contentType_form`);

// 国际机票列表
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/international/buyer/manage/order/list',
    data:data
  }

  return __request(pParameter)
}

